import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {LoginAsPartnerPayloadInterface} from "@/api/Partners/LoginAs/Interfaces/LoginAsPartnerPayloadInterface";
import {LoginAsPartnerResponseDataInterface} from "@/api/Partners/LoginAs/Interfaces/LoginAsPartnerResponseDataInterface";
import {RevertLoginAsResponseDataInterface} from "@/api/Partners/LoginAs/Interfaces/RevertLoginAsResponseDataInterface";

const restApiConfig = new RESTAPIConfig();

export const LoginAsPartnerApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        loginAsPartner: builder.mutation<LoginAsPartnerResponseDataInterface, LoginAsPartnerPayloadInterface>({
            query: (body) => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.loginAsPartnerSwitch(),
                method: "POST",
                body,
            }),
        }),

        revertLoginAs: builder.mutation<RevertLoginAsResponseDataInterface, void>({
            query: () => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.loginAsPartnerRevert(),
                method: "POST",
            }),
        }),
    })
});

export const {useLoginAsPartnerMutation, useRevertLoginAsMutation} = LoginAsPartnerApiSlice;
